import React, { PropTypes } from 'react';
import { defaultThumbnail } from 'utils/assets';
import AsyncImage from 'common/components/AsyncImage';

const paragraphImageUrl = paragraph => {
  if (paragraph.image && paragraph.image.web) {
    return paragraph.image.web;
  }

  return paragraph.thumbnail || defaultThumbnail();
};

const ImageParagraph = ({ paragraph }) => (
  <div className="inner">
    <AsyncImage src={paragraphImageUrl(paragraph)} />
  </div>
);

ImageParagraph.propTypes = {
  paragraph: PropTypes.object.isRequired,
};

export default ImageParagraph;



// WEBPACK FOOTER //
// ./src/modules/memo/components/ImageParagraph.js